import type { SymbolDefinition } from "../types.ts";

export const meter: SymbolDefinition = {
  id: "ep-meter",
  familyKey: "meter",
  deviceKind: "meter",
  version: "0.1.0",
  label: { sv: "Mätare", en: "Meter" },
  description: { sv: "Kilowatt-timmätare.", en: "Energy meter." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="24" cy="24" r="14"/>
      <text x="24" y="27" text-anchor="middle" font-size="8" fill="currentColor" stroke="none">kWh</text>
      <line x1="24" y1="10" x2="24" y2="2"/>
      <line x1="24" y1="38" x2="24" y2="46"/>
    </g>
  `,
  terminals: [
    { id: "in", kind: "phase", label: "L", position: "top", offset: 0.5 },
    { id: "out", kind: "phase", label: "T", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "P",
  searchKeywords: ["mätare", "kwh", "elmätare"],
};
